import {EventBase} from "shared/utilities/Events/EventManager";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";

export class OpenProperties extends EventBase {
    ReturnType: void;

    constructor(public Item:PDFControlBase)
    {
        super();
    }

    public static GetName() {
        return 'OpenProperties';
    }
}